import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { Angulartics2 } from 'angulartics2';

import {APP_SETTINGS } from '../../modules/ng-express-engine/tokens';

declare var dataLayer: any;
declare var _etmc: any;

@Injectable()
export class Angulartics2Vdgm {

  protected isServer: boolean;

  constructor(
    @Inject(PLATFORM_ID) platformId: string,
    private angulartics2: Angulartics2,
    @Inject(APP_SETTINGS) private settings: Object
  ) {
    this.isServer = isPlatformServer(platformId); 

    // The dataLayer needs to be initialized
    if (typeof dataLayer !== 'undefined' && dataLayer) {
      dataLayer = (<any>window).dataLayer = (<any>window).dataLayer || [];
    }

    //this.angulartics2.settings.pageTracking.trackRelativePath = true;

    // Set the default settings for this module
    this.angulartics2.settings.gtm = {
      userId: null
    };

    this.angulartics2.pageTrack.subscribe((x: any) => this.pageTrack(x.path, ""));

    this.angulartics2.eventTrack.subscribe((x: any) => this.eventTrack(x.action, x.properties));

    this.angulartics2.exceptionTrack.subscribe((x: any) => this.exceptionTrack(x));

    this.angulartics2.setUsername.subscribe((x: string) => this.setUsername(x,""));
  }

  pageTrack(path: string, uniqueId: string) {
    if(this.isServer)
      return;

    if (typeof dataLayer !== 'undefined' && dataLayer) {
      dataLayer.push({
        'event': 'Page View',
        'content-name': path,
        'uniqueId': uniqueId
      });
    }
  }

  screenTrack(screen: string, title: string = '', slug: string = '') {
    if(this.isServer)
      return;

    if (typeof dataLayer !== 'undefined' && dataLayer) {
      dataLayer.push({
        'event': 'Screen View',
        'screenName': screen,
        'deviceModel': window["device"]["model"],
        'deviceVersion': window["device"]["version"],
        'deviceContentTitle': title,
        'deviceContentSlug': slug,
        'appId': this.settings["APPID"],
        'appName': this.settings["APPNAME"],
        'appVersion': this.settings["APPVERSION"]
      });
    }
  }

  /**
   * Send interactions to the dataLayer, i.e. for event tracking in Google Analytics
   * @name eventTrack
   *
   * @param {string} action Required 'action' (string) associated with the event
   * @param {object} properties Comprised of the mandatory field 'category' (string) and optional  fields 'label' (string), 'value' (integer) and 'noninteraction' (boolean)
   */
  eventTrack(action: string, properties: any) {
      if(this.isServer)
        return;

      // Set a default GTM category
      properties = properties || {};
      properties.event = properties.event || 'interaction';
      properties.target = properties.category || 'Event';
      properties.interactionType = properties.noninteraction;
      properties.action = action;

      if(this.settings["API_HEADERS"]["X-PLATFORM"] == 'OTT')
      {
        properties.deviceModel = window["device"]["model"];
        properties.deviceVersion = window["device"]["version"];        
        properties.appId = this.settings["APPID"],
        properties.appName = this.settings["APPNAME"],
        properties.appVersion = this.settings["APPVERSION"]
      }

      if (typeof dataLayer !== 'undefined' && dataLayer) {
        dataLayer.push(properties);
      }

  }

  /**
   * Exception Track Event in GTM
   * @name exceptionTrack
   *
   * @param {object} properties Comprised of the mandatory fields 'appId' (string), 'appName' (string) and 'appVersion' (string) and
   * optional  fields 'fatal' (boolean) and 'description' (string)
   */
  exceptionTrack(properties: any) {
    if(this.isServer)
      return;

    if (! properties || ! properties.appId || ! properties.appName || ! properties.appVersion) {
      console.error('Must be setted appId, appName and appVersion.');
      return;
    }

    if (properties.fatal === undefined) {
      console.log('No "fatal" provided, sending with fatal=true');
      properties.exFatal = true;
    }

    properties.exDescription = properties.event ? properties.event.stack : properties.description;

    this.eventTrack(`Exception thrown for ${properties.appName} <${properties.appId}@${properties.appVersion}>`, {
      'category': 'Exception',
      'label': properties.exDescription
    });
  }

  /**
   * Set userId for use with Universal Analytics User ID feature
   * @name setUsername
   *
   * @param {string} userId Required 'userId' value (string) used to identify user cross-device in Google Analytics
   */
  setUsername(userId: string, email: string) {
    if(this.isServer)
      return;

    this.angulartics2.settings.gtm.userId = userId;
    dataLayer.push({
      'userId': userId
    });
    if(_etmc)
    {
      _etmc.push(["setUserInfo", {"email": email}]);
    }
    
  }
}


// WEBPACK FOOTER //
// ./src/angular-engine/engine/providers/Angulartics2Vdgm.ts